/**
 * RedTeam Xperience (student web app) — where a candidate came from, and where they
 * go back to when the exam is over.
 *
 * Only the origin is configured (REACT_APP_EXPERIENCE_APP_URL); the paths live here
 * so there is a single place to change them. Like every REACT_APP_* value this is
 * inlined at build time — see .env.example.
 *
 * Note this is the *student app* origin, not REACT_APP_EXPERIENCE_BASE_URL (the
 * Laravel v3 API used for login/OTP/SSO). They are usually different hosts.
 */

const appUrl = (process.env.REACT_APP_EXPERIENCE_APP_URL || "").replace(
  /\/+$/,
  ""
);

/**
 * The candidate's "My Exams" page in Xperience, where a submitted attempt shows up
 * with its result. Returns "" when the app URL isn't configured, so callers can fall
 * back to staying inside the portal rather than navigating somewhere broken.
 */
export function experienceExamsUrl(): string {
  return appUrl ? `${appUrl}/exams` : "";
}
